/**
 * Adressen til Control Room › Spillesteder (QA15-S E): fanen, søket, statusfilteret og stedet som er
 * åpent. E-posten om en forespørsel til et sted utenfor Tvitvi lenker til `?tab=requests`.
 */
export const VENUE_DIRECTORY_TABS = ['venues', 'requests'] as const;
export type VenueDirectoryTab = (typeof VENUE_DIRECTORY_TABS)[number];

export interface ControlRoomVenuesSearch {
  tab?: VenueDirectoryTab;
  q?: string;
  status?: 'verified' | 'unverified';
  venue?: string;
}

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() !== '' ? value.trim().slice(0, 120) : undefined;

export function validateControlRoomVenuesSearch(
  search: Record<string, unknown>,
): ControlRoomVenuesSearch {
  const out: ControlRoomVenuesSearch = {};
  const tab = search['tab'];
  if (typeof tab === 'string' && (VENUE_DIRECTORY_TABS as readonly string[]).includes(tab)) {
    out.tab = tab as VenueDirectoryTab;
  }
  const q = text(search['q']);
  if (q !== undefined) out.q = q;
  if (search['status'] === 'verified' || search['status'] === 'unverified') {
    out.status = search['status'];
  }
  const venue = text(search['venue']);
  if (venue !== undefined && /^[0-9a-f-]{36}$/u.test(venue)) out.venue = venue;
  return out;
}
